/*
  Holiday gift with purchase (a1393, 2026-10-26). Keeps exactly one $0 gift in
  the cart while the cart total (after discounts, not counting the gift) is at
  or above the minimum, and none below it or when the gift is the only item.
  Runs on page load and after every cart update, then refreshes the cart
  drawer, or reloads the cart page, when it changed something.
*/
(() => {
  const config = window.holidayGwp;
  if (!config || !config.variantId) return;

  let busy = false;
  let again = false;

  const refreshDrawer = async () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const response = await fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`);
    const sections = await response.json();
    const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
    const inner = drawer.querySelector('.drawer__inner');
    const newInner = sections['cart-drawer'] && parse(sections['cart-drawer']).querySelector('.drawer__inner');
    if (inner && newInner) inner.innerHTML = newInner.innerHTML;
    const bubble = document.getElementById('cart-icon-bubble');
    const newBubble = sections['cart-icon-bubble'] && parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
    if (bubble && newBubble) bubble.innerHTML = newBubble.innerHTML;
  };

  const sync = async () => {
    if (busy) { again = true; return; }
    busy = true;
    try {
      const cart = await (await fetch(`${window.routes ? window.routes.cart_url : '/cart'}.js`)).json();
      const giftLines = cart.items.filter((item) => item.variant_id === config.variantId);
      const giftQuantity = giftLines.reduce((sum, item) => sum + item.quantity, 0);
      const giftTotal = giftLines.reduce((sum, item) => sum + item.final_line_price, 0);
      const otherItems = cart.item_count - giftQuantity;
      const eligible = otherItems > 0 && cart.total_price - giftTotal >= config.minimum;
      const wanted = eligible ? 1 : 0;
      if (giftQuantity === wanted && giftLines.length <= 1) return;

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: { [config.variantId]: wanted } })
      });
      if (document.querySelector('cart-items:not(cart-drawer-items)') && window.location.pathname.endsWith('/cart')) {
        window.location.reload();
        return;
      }
      await refreshDrawer();
    } catch (error) {
      console.warn('holiday-gwp', error);
    } finally {
      busy = false;
      if (again) { again = false; sync(); }
    }
  };

  const start = () => {
    sync();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(sync, 300));
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
